/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Wed Dec 27 2023
 **/

import styled from "@emotion/styled";

import { Icon, Row } from "@/frameworks/designStuff/components";

interface ChatType {
	size: "full" | "mini";
}

export const VoiceCallWrapper = styled.div<ChatType>`
	display: flex;
	flex-direction: row;
	padding: 12px 10px;
	position: relative;
	width: 100%;
	height: fit-content;
	justify-content: space-between;
	border-radius: ${(props) => (props.size === "full" ? "8px" : 0)};
	background-color: ${({ theme }) => theme.colors.accent_40_100};
`;

export const IconBackground = styled(Row)`
	border-radius: 100%;
	width: 28px;
	height: 28px;
	justify-content: center;
	align-items: center;
`;

export const RecordStart = styled.div`
	width: 12px;
	height: 12px;
	border-radius: 100%;
	background-color: #ff4848;
`;

export const RecordStop = styled.div`
	width: 12px;
	height: 12px;
	background-color: ${({ theme }) => theme.colors.accent_80_100};
`;

export const VerticalDivider = styled.div`
	height: 28px;
	padding: 4px;
	border-left: 1px solid ${({ theme }) => theme.colors.accent_50_100};
`;

export const Record = styled(Row)`
	width: 30px;
	height: 18px;
	border-radius: 10px;
	justify-content: center;
	align-items: center;
	color: ${({ theme }) => theme.colors.neutral_00_100};
	background-color: ${({ theme }) => theme.colors.error_60_100};
`;

export const UserCountWrapper = styled(Row)`
	margin-left: 10px;
	border: 1px solid rgba(0, 0, 0, 0.07);
	padding: 2px 4px;
	border-radius: 4px;
	background-color: ${({ theme }) => theme.colors.accent_20_100};
	height: 20px;
	justify-content: center;
	align-items: center;
	&:hover {
		background-color: ${({ theme }) => theme.colors.accent_10_100};
	}
	gap: 2px;
	cursor: pointer;
`;

export const StyledIcon = styled(Icon)`
	cursor: pointer;
`;
